
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17 20","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.692 16.735H2.93V8.283a5.377 5.377 0 1110.755 0v8.452h.007z","stroke":"#232323","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M6.41 2.905C6.41 1.855 7.258 1 8.308 1c1.05 0 1.905.855 1.905 1.905M10.212 16.735c0 1.05-.855 1.905-1.905 1.905a1.908 1.908 0 01-1.905-1.905M1.25 16.735h14.123","stroke":"#232323","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    